// @ts-nocheck
export function getTextWidthAndHeight(
  text: string,
  containerWidth: number,
  padding: number = 0,
  gap: number = 0,
  font: string = '14px Inter',
  lineHeight: number = 19
): { height: number; width: number } {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) {
    return {
      height: 0,
      width: 0
    };
  }
  context.font = font;
  const words = text.split(' ');
  let lineWidth = 0;
  let rows = 1;
  words.forEach(word => {
    const wordWidth = context.measureText(`${word} `).width;
    if (lineWidth + wordWidth > containerWidth) {
      rows++;
      lineWidth = wordWidth;
    } else {
      lineWidth += wordWidth;
    }
  });
  return {
    height: rows * lineHeight + padding * 2 + gap * (rows - 1),
    width: lineWidth
  };
}
